<!--
 * @Description: 新增/编辑员工时区弹窗
 * @Author: mdb
 * @Date: 2023-03-08 16:58:48
 * @LastEditTime: 2023-04-12 11:12:32
 * @LastEditors: mdb
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :width="600"
    :title="modalTitle"
    :confirmLoading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :wrapper-col="{ span: 24 }" ref="formRef" :model="dataForm">
      <a-form-item label="员工" name="employeeNo" :rules="formRules.select">
        <UserSelect v-model:value="dataForm.employeeNo" :status="1" allowClear :disabled="rowsProps" />
      </a-form-item>
      <a-form-item label="时区" name="timeZoneId" :rules="formRules.select">
        <a-select
          v-model:value="dataForm.timeZoneId"
          :options="timeZoneEnum"
          show-search
          placeholder="请选择"
          :filter-option="filterOption"
          allowClear
        />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, reactive, computed } from 'vue'
import { timeZoneEnum } from '../timeZoneEnum'
import { message as DcMessage } from '@dc-platform/dc-components'
import { personTimeZoneCreate, personTimeZoneEdit } from '@/api/common'
import type { PersonTimeZoneEditParams, PersonTimeZoneListItem } from '@/typings/api/overseasSales'

const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = reactive<PersonTimeZoneEditParams>({})
const formRules = reactive({
  select: [{ required: true, message: '请选择' }]
})
const emit = defineEmits(['fetch'])

const rowsProps = ref<PersonTimeZoneListItem>()
// 弹窗标题
const modalTitle = computed(() => (rowsProps.value ? '编辑' : '新增'))
const init = (rows?: PersonTimeZoneListItem) => {
  rowsProps.value = rows
  if (rows) {
    dataForm.id = rows.id
    dataForm.employeeNo = rows.employeeNo
    dataForm.timeZoneId = rows.timeZoneId
  }
  visible.value = true
}
const filterOption = (input: string, option: { label: string; value: string }) => {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
const handleOk = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const params = rowsProps.value
      ? { id: rowsProps.value.id, timeZoneId: dataForm.timeZoneId }
      : { timeZoneId: dataForm.timeZoneId, employeeNo: dataForm.employeeNo }
    const func = rowsProps.value ? personTimeZoneEdit : personTimeZoneCreate
    func(params)
      .then(() => {
        DcMessage.success('操作成功！')
        emit('fetch')
        handleCancel()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
  setTimeout(() => {
    visible.value = false
  }, 20)
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'ModalForm' }
</script>

<style scoped></style>
